enum TrustedDeviceCols {
  OS = 'OS',
  BROWSER = 'BROWSER',
  CREATION_DATE = 'CREATION_DATE',
  STATUS = 'STATUS',
}

export default TrustedDeviceCols;
